import React from 'react';

const ArrowRight = props => (
  <svg width="20" height="17" viewBox="0 0 20 17" {...props}>
    <path
      d="M12 1.68973L19 8.68973M19 8.68973L12 15.6897M19 8.68973L1 8.68973"
      stroke="#626262"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowRight.displayName = 'ArrowRight';

export default ArrowRight;
